(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bedz-dock48-options"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('bedz-dock48-options'))customElements.define('bedz-dock48-options',class extends HTMLElement{
 connectedCallback(){
  this.form=this.closest('form');if(!this.form)return;
  this.data=JSON.parse(this.querySelector('[data-option-products]').textContent);this.choice=this.querySelector('[data-underbed]');this.total=this.querySelector('[data-option-total]');this.error=this.querySelector('[data-option-error]');this.preview=this.querySelector('[data-option-preview]');this.previewImage=this.querySelector('[data-option-image]');this.previewName=this.querySelector('[data-option-name]');this.busy=false;
  this.change=()=>this.refresh();this.form.addEventListener('change',this.change);this.choice.addEventListener('change',this.change);
  this.submit=e=>{if(this.choice.value==='none')return;e.preventDefault();e.stopImmediatePropagation();this.add()};
  this.click=e=>{if(e.target.closest('[data-product-add]')&&this.choice.value!=='none'){e.preventDefault();e.stopImmediatePropagation();this.add()}};
  this.form.addEventListener('submit',this.submit,true);this.form.addEventListener('click',this.click,true);
  this.galleryClick=e=>{const thumb=e.target.closest('[data-dock48-addon-thumbnail]');if(!thumb)return;const mediaId=thumb.querySelector('[data-media-id]')?.dataset.mediaId;if(!mediaId)return;const media=document.querySelector('.product-media-item[data-media-id="'+mediaId+'"]');const track=media?.closest('[data-product-images]');const slide=media?.closest('.slick-slide')||media;const index=slide?.dataset.slickIndex;if(track&&index!==undefined&&window.jQuery&&jQuery(track).hasClass('slick-initialized')){e.preventDefault();e.stopImmediatePropagation();jQuery(track).slick('slickGoTo',Number(index))}};
  document.addEventListener('click',this.galleryClick,true);
  const size=this.querySelector('[data-bed-size]'),access=this.querySelector('[data-bed-access]');
  if(size){size.value=this.data.bed.handle.includes('full-full')?'full-full':this.data.bed.handle.includes('twin-full')?'twin-full':'twin-twin';access.value=this.data.bed.handle.endsWith('-with-stairs')?'-with-stairs':'';
   this.navigate=()=>{const handle='dock48-beadboard-'+size.value+'-bunk-bed'+access.value,other=this.data.families[handle];if(!other?.variants?.length)return;const target=this.familyVariant(size.value,access.value);if(!target)return;const url=new URL('/products/'+handle,location.origin);url.searchParams.set('variant',target.id);const preview=new URL(location.href).searchParams.get('preview_theme_id');if(preview)url.searchParams.set('preview_theme_id',preview);if(this.choice.value!=='none')url.searchParams.set('underbed',this.choice.value);location.assign(url)};size.addEventListener('change',this.navigate);access.addEventListener('change',this.navigate)
  }
  const wanted=new URL(location.href).searchParams.get('underbed');if(['drawers','trundle','captains'].includes(wanted)&&this.choice.querySelector('option[value="'+wanted+'"]'))this.choice.value=wanted;
  this.timer=setInterval(()=>this.refresh(),400);this.refresh();
 }
 disconnectedCallback(){clearInterval(this.timer);this.form?.removeEventListener('change',this.change);this.form?.removeEventListener('submit',this.submit,true);this.form?.removeEventListener('click',this.click,true);document.removeEventListener('click',this.galleryClick,true)}
 bedVariant(){const id=this.form.querySelector('[name="id"]')?.value;return this.data.bed.variants.find(v=>String(v.id)===String(id))}
 color(v,p=this.data.bed){const index=p.options.findIndex(o=>['Color','Finish'].includes(typeof o==='string'?o:o.name));return index>=0?v?.options[index]:null}
 addon(){const p=this.data[this.choice.value],color=this.color(this.bedVariant());return p?.variants?.find(v=>this.color(v,p)===color&&v.available)}
 money(cents){return new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:this.dataset.currency}).format(cents/100)}
 familyVariant(size,access){const p=this.data.families['dock48-beadboard-'+size+'-bunk-bed'+access];return p?.variants?.find(v=>v.available&&this.color(v,p)===this.color(this.bedVariant()))}
  image(v,p){const image=v?.featured_image;if(!image)return null;return typeof image==='string'?image:(image.src||image.url)}
  syncGallery(kind,p,v){const image=this.image(v,p);if(!image){const example=p?.variants?.find(item=>item.featured_image);const exampleColor=example?this.color(example,p):null;document.querySelectorAll('[data-dock48-addon-media="'+kind+'"] [class*="__label"]').forEach(label=>{const text=exampleColor?exampleColor+' example · selected finish: '+this.color(v,p):'Photo unavailable for '+this.color(v,p);if(label.textContent!==text)label.textContent=text});return;}const secure=String(image).replace(/^http:/,'https:'),alt='Optional '+p.title+' — '+this.color(v,p);document.querySelectorAll('[data-dock48-addon-media="'+kind+'"] img').forEach(img=>{img.src=secure;img.srcset='';img.dataset.highRes=secure;if(window.jQuery)window.jQuery(img).data('high-res',secure);img.alt=alt});document.querySelectorAll('[data-dock48-addon-media="'+kind+'"] [class*="__label"]').forEach(label=>label.textContent='Optional storage · '+this.color(v,p));document.querySelectorAll('[data-dock48-addon-thumbnail="'+kind+'"] img').forEach(img=>{img.src=secure;img.srcset='';img.dataset.productThumbnailSrc=secure;img.alt=alt})}
  refresh(){const state=[this.bedVariant()?.id,this.choice.value].join('|');if(state===this.lastState)return;this.lastState=state;const size=this.querySelector('[data-bed-size]'),access=this.querySelector('[data-bed-access]');if(size&&access){for(const o of size.options)o.disabled=!this.familyVariant(o.value,access.value);for(const o of access.options)o.disabled=!this.familyVariant(size.value,o.value)}for(const kind of ['drawers','trundle','captains']){const p=this.data[kind],v=p?.variants?.find(v=>this.color(v,p)===this.color(this.bedVariant())&&v.available),option=this.choice.querySelector('option[value="'+kind+'"]');if(option){option.disabled=!v;option.textContent=this.data.text[kind]+(v?' — +'+this.money(v.price):'')}if(v)this.syncGallery(kind,p,v)}const selected=this.choice.value!=='none',bed=this.bedVariant(),addon=selected?this.addon():null,addonProduct=selected?this.data[this.choice.value]:null;this.total.textContent=selected&&bed&&addon?this.data.text.total+' '+this.money(bed.price+addon.price):'';this.preview.hidden=!selected;if(selected){this.previewName.textContent=addonProduct?.title||this.choice.selectedOptions[0]?.textContent||'';const image=this.image(addon,addonProduct);if(image){this.previewImage.src=String(image).replace(/^http:/,'https:');this.previewImage.alt=(addonProduct?.title||'Selected storage option');this.previewImage.hidden=false}else{this.previewImage.removeAttribute('src');this.previewImage.hidden=true}}const invalid=selected&&!addon;this.error.hidden=!invalid;this.error.textContent=invalid?this.data.text.missing:'';this.form.querySelectorAll('.shopify-payment-button').forEach(el=>{if(selected&&!el.hidden){el.dataset.dock48Hidden='true';el.hidden=true}else if(!selected&&el.dataset.dock48Hidden){el.hidden=false;delete el.dataset.dock48Hidden}})}
 async add(){if(this.busy)return;const bed=this.bedVariant(),addon=this.addon();if(!bed||!addon||!bed.available){this.error.hidden=false;this.error.textContent=this.data.text.missing;return}this.busy=true;const button=this.form.querySelector('[data-product-add]');if(button)button.disabled=true;try{const quantity=Math.max(1,parseInt(this.form.querySelector('[name="quantity"]')?.value||'1',10));const properties={};properties[this.data.text.for_bed]=this.data.bed.title;const res=await fetch(this.dataset.addUrl,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:bed.id,quantity},{id:addon.id,quantity,properties}]})});const result=await res.json();if(!res.ok)throw Error(result.description||this.data.text.error);location.assign(this.dataset.cartUrl)}catch(err){this.error.hidden=false;this.error.textContent=err.message||this.data.text.error;this.busy=false;if(button)button.disabled=false}}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bedz-jay-options"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('bedz-jay-options'))customElements.define('bedz-jay-options',class extends HTMLElement{connectedCallback(){this.form=this.closest('form');if(!this.form)return;this.data=JSON.parse(this.querySelector('[data-products]').textContent);this.radios=[...this.querySelectorAll('input[type=radio]')];this.preview=this.querySelector('[data-preview]');this.image=this.querySelector('[data-image]');this.name=this.querySelector('[data-name]');this.price=this.querySelector('[data-price]');this.error=this.querySelector('[data-error]');this.busy=false;this.radios.forEach(r=>r.addEventListener('change',()=>this.refresh()));this.form.addEventListener('change',()=>this.refresh());this.form.addEventListener('submit',e=>{if(this.choice()!=='none'){e.preventDefault();e.stopImmediatePropagation();this.add()}},true);this.form.addEventListener('click',e=>{if(e.target.closest('[data-product-add]')&&this.choice()!=='none'){e.preventDefault();e.stopImmediatePropagation();this.add()}},true);this.refresh()}choice(){return this.radios.find(r=>r.checked)?.value||'none'}bed(){const id=this.form.querySelector('[name=id]')?.value;return this.data.bed.variants.find(v=>String(v.id)===String(id))}finish(v,p=this.data.bed){const i=p.options.findIndex(o=>['Color','Finish'].includes(typeof o==='string'?o:o.name));return i<0?'':String(v?.options[i]||'').replace('Grey','Gray')}addon(kind=this.choice()){const p=this.data[kind],f=this.finish(this.bed());return p?.variants?.find(v=>this.finish(v,p)===f&&v.available)}img(v,p){const x=v?.featured_image||p?.featured_image;return typeof x==='string'?x:(x?.src||x?.url)}money(c){return new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:this.dataset.currency}).format(c/100)}refresh(){for(const kind of ['drawers','trundle']){const radio=this.radios.find(r=>r.value===kind);if(radio)radio.disabled=!this.addon(kind)}const kind=this.choice(),p=this.data[kind],v=kind==='none'?null:this.addon(kind);this.preview.hidden=!v;this.error.hidden=true;if(v){this.name.textContent=p.title;this.price.textContent='Add '+this.money(v.price);this.image.src=String(this.img(v,p)).replace(/^http:/,'https:');this.image.alt=p.title+' — '+this.finish(v,p)}if(kind!=='none'&&!v){this.error.hidden=false;this.error.textContent='This option is not available in the selected finish.'}this.form.querySelectorAll('.shopify-payment-button').forEach(el=>el.hidden=kind!=='none')}async add(){if(this.busy)return;const bed=this.bed(),kind=this.choice(),addon=this.addon(kind);if(!bed||!addon){this.refresh();return}this.busy=true;try{const q=Math.max(1,parseInt(this.form.querySelector('[name=quantity]')?.value||'1',10));const r=await fetch(this.dataset.addUrl,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:bed.id,quantity:q},{id:addon.id,quantity:q,properties:{'For bed':this.data.bed.title}}]})});const x=await r.json();if(!r.ok)throw Error(x.description||'Unable to add this configuration.');location.assign(this.dataset.cartUrl)}catch(e){this.busy=false;this.error.hidden=false;this.error.textContent=e.message}}});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bedz-jay-underbed"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bedz-jay-underbed')) {
  customElements.define('bedz-jay-underbed', class extends HTMLElement {
    connectedCallback() {
      this.form = this.closest('form');
      this.bed = JSON.parse(this.querySelector('[data-jay-bed]').textContent);
      this.accessories = JSON.parse(this.querySelector('[data-jay-accessories]').textContent);
      this.choice = this.querySelector('[data-jay-choice]');
      this.choiceRadios = [...this.querySelectorAll('[data-jay-choice-radio]')];
      this.stairs = this.querySelector('[data-jay-stairs]');
      this.stairPrice = this.querySelector('[data-jay-stair-price]');
      this.item = this.querySelector('[data-jay-item]');
      this.price = this.querySelector('[data-jay-price]');
      this.error = this.querySelector('[data-jay-error]');
      this.form.addEventListener('change', () => setTimeout(() => this.refresh(), 100));
      this.form.addEventListener('click', event => {
        if (event.target.closest('[data-product-add]') && this.hasExtras()) {
          event.preventDefault(); event.stopImmediatePropagation(); this.add();
        }
      }, true);
      this.form.addEventListener('submit', event => {
        if (this.hasExtras()) { event.preventDefault(); event.stopImmediatePropagation(); this.add(); }
      }, true);
      if (this.choice && new URLSearchParams(window.location.search).get('jay_underbed')) this.choice.value = new URLSearchParams(window.location.search).get('jay_underbed');
      this.choiceRadios.forEach(radio => radio.addEventListener('change', () => { if (radio.checked) { this.choice.value = radio.value; this.refresh(); } }));
      for (const thumbnail of document.querySelectorAll('[data-jay-addon-thumbnail]')) {
        thumbnail.addEventListener('click', event => {
          event.preventDefault();
          event.stopImmediatePropagation();
          const kind = thumbnail.getAttribute('data-jay-addon-thumbnail');
          const radio = this.choiceRadios.find(item => item.value === kind);
          if (!radio || radio.disabled) return;
          radio.checked = true;
          this.choice.value = kind;
          this.refresh();
        }, true);
      }
      const initialChoice = this.choiceRadios.find(radio => radio.value === this.choice?.value); if (initialChoice) initialChoice.checked = true;
      if (this.stairs) {
        if (new URLSearchParams(window.location.search).get('jay_stairs') === 'stairs' && !this.dataset.stairModel) this.stairs.value = 'stairs';
        this.stairs.addEventListener('change', () => {
          if (this.dataset.stairModel && this.stairs.value === 'stairs') {
            this.refresh();
            if (this.stairModelMatch) window.location.assign(this.dataset.root + 'products/' + this.dataset.stairModel + '?variant=' + this.stairModelMatch.id + '&jay_stairs=stairs&jay_underbed=' + encodeURIComponent(this.choice ? this.choice.value : 'none'));
          }
        });
      }
      this.refresh();
    }
    hasExtras() { return (this.choice && this.choice.value !== 'none') || (this.stairs && this.stairs.value !== 'none'); }
    normalize(value) { return String(value || '').toLowerCase().replace('grey', 'gray').trim(); }
    matchingAccessories(choice, color, isXL, wide) {
      const matches = [];
      const groups = choice === 'drawers' ? [isXL ? 'xl' : 'regular'] : choice === 'trundle' ? ['twin', ...(wide ? ['full'] : [])] : [];
      for (const key of groups) {
        const accessory = this.accessories[key];
        if (!accessory || !accessory.variants) continue;
        const ci = accessory.options.findIndex(o => /color|finish/i.test(typeof o === 'string' ? o : o.name));
        for (const av of accessory.variants) {
          if (!av.available || this.normalize(av.options[ci]) !== color) continue;
          const asize = av.options.filter((v,i) => i !== ci).join(' ').toLowerCase();
          if (choice === 'trundle' && /xl/.test(asize) !== isXL) continue;
          matches.push({
            id: av.id,
            price: av.price,
            title: accessory.title + ' — ' + av.title,
            image: (this.accessories[key + '_images'] || {})[String(av.id)] || av.featured_image || null
          });
        }
      }
      return matches;
    }
    selectGalleryMedia(media, attempt = 0) {
      if (!media) return;
      const track = media.closest('[data-product-images]');
      const slide = media.closest('.slick-slide') || media;
      const index = slide.dataset.slickIndex;
      if (track && index !== undefined && window.jQuery && window.jQuery(track).hasClass('slick-initialized')) {
        clearTimeout(this.galleryRetry);
        if (!slide.classList.contains('slick-current')) window.jQuery(track).slick('slickGoTo', Number(index));
      } else if (attempt < 20) {
        clearTimeout(this.galleryRetry);
        this.galleryRetry = setTimeout(() => this.selectGalleryMedia(media, attempt + 1), 100);
      }
    }
    showAccessoryImage(choice, accessory) {
      if (!accessory || !accessory.image || choice === 'none') return;
      const kind = choice === 'drawers' ? 'drawers' : 'trundle';
      const media = document.querySelector('[data-jay-addon-media="' + kind + '"]');
      const thumbnail = document.querySelector('[data-jay-addon-thumbnail="' + kind + '"] img');
      if (!media || !thumbnail) return;
      const image = accessory.image;
      const source = image.src || image.url;
      if (!source) return;
      const alt = 'Optional ' + accessory.title;
      const mainImage = media.querySelector('img');
      if (mainImage) {
        mainImage.removeAttribute('srcset');
        mainImage.src = source;
        mainImage.dataset.highRes = source;
        if (window.jQuery) window.jQuery(mainImage).data('high-res', source);
        mainImage.alt = alt;
        if (image.width) mainImage.width = image.width;
        if (image.height) mainImage.height = image.height;
        mainImage.style.width = '100%';
        mainImage.style.height = 'auto';
        mainImage.style.objectFit = 'contain';
      }
      if (image.width && image.height) media.dataset.mediaAspect = String(image.width / image.height);
      media.style.height = 'auto';
      media.style.minHeight = '0';
      const cleanSource = source.split('?')[0];
      const filesIndex = cleanSource.lastIndexOf('/files/');
      const productsIndex = cleanSource.lastIndexOf('/products/');
      const imagePath = filesIndex >= 0
        ? cleanSource.slice(filesIndex + 1)
        : productsIndex >= 0
          ? cleanSource.slice(productsIndex + 1)
          : cleanSource;
      media.setAttribute('data-product-image-src', imagePath);
      thumbnail.removeAttribute('srcset');
      thumbnail.src = source;
      thumbnail.setAttribute('data-product-thumbnail-src', source);
      thumbnail.alt = alt;
      this.selectGalleryMedia(media);
    }
    showBedImage(variant) {
      const image = variant && (variant.featured_image || variant.featured_media && variant.featured_media.preview_image);
      const source = image && (image.src || image.url);
      const thumbnails = [...document.querySelectorAll('.product-thumbnail[data-product-thumbnail-src]')]
        .filter(item => !item.closest('[data-jay-addon-thumbnail]'));
      const clean = value => String(value || '').split('?')[0].replace(/^https?:\/\/[^/]+\//, '').replace(/^\//, '');
      const wanted = clean(source);
      const match = wanted
        ? thumbnails.find(item => {
            const candidate = clean(item.getAttribute('data-product-thumbnail-src') || item.src);
            return candidate === wanted || candidate.endsWith(wanted) || wanted.endsWith(candidate);
          })
        : null;
      const id = (match || thumbnails[0])?.dataset.mediaId;
      if (id) this.selectGalleryMedia(document.querySelector('.product-media-item[data-media-id="' + id + '"]'));
    }
    showRileyConfiguration(variant, choice) {
      if (!['beadboard-bunk-bed', 'riley-ii-bunk-bed'].includes(this.bed.handle)) return false;
      const option = name => {
        const index = this.bed.options.findIndex(item => new RegExp(name, 'i').test(typeof item === 'string' ? item : item.name));
        return index >= 0 ? variant.options[index] : '';
      };
      const size = this.normalize(option('size')).replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
      if (this.bed.handle === 'riley-ii-bunk-bed') {
        const finish = this.normalize(option('color|finish')).replace(/[^a-z0-9]+/g, '-');
        const access = this.stairs?.value === 'stairs' ? 'stairs' : 'ladder';
        const key = [size, finish, choice || 'none', access].join('|');
        const media = document.querySelector('[data-riley-ii-config="' + key + '"]');
        if (!media) return false;
        this.selectGalleryMedia(media);
        return true;
      }
      if (!['twin-twin', 'full-full', 'queen-queen', 'twin-full', 'twin-xl-queen'].includes(size)) return false;
      // Queen/Queen uses Full/Full photography, while Twin XL/Queen uses
      // Twin/Full photography because those pairs share storefront proportions.
      const mediaSize = size === 'queen-queen'
        ? 'full-full'
        : size === 'twin-xl-queen'
          ? 'twin-full'
          : size;
      const finish = this.normalize(option('color|finish')).replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
      const storage = choice === 'drawers' ? 'drawers' : choice === 'trundle' ? 'trundle' : 'none';
      const key = [mediaSize, finish, storage].join('|');
      const media = document.querySelector('[data-riley-config="' + key + '"]');
      const id = media?.dataset.mediaId;
      const thumbnail = id ? document.querySelector('.product-thumbnail[data-media-id="' + id + '"]') : null;
      if (!thumbnail) return false;
      this.selectGalleryMedia(media);
      return true;
    }
    refresh() {
      const variant = this.bed.variants.find(v => String(v.id) === String(new FormData(this.form).get('id')));
      if (!variant) return;
      const colorIndex = this.bed.options.findIndex(o => /color|finish/i.test(typeof o === 'string' ? o : o.name));
      const color = this.normalize(variant.options[colorIndex]);
      const size = [this.bed.title, ...variant.options.filter((v,i) => i !== colorIndex)].join(' ').toLowerCase();
      const isXL = /xl|queen|king/.test(size);
      const wide = /full|queen|king/.test(size);
      const previous = this.item ? this.item.value : '';
      for (const radio of this.choiceRadios) radio.disabled = radio.value !== 'none' && this.matchingAccessories(radio.value, color, isXL, wide).length === 0;
      if (this.choiceRadios.find(radio => radio.checked)?.disabled) { this.choice.value = 'none'; this.choiceRadios.find(radio => radio.value === 'none').checked = true; }
      const choice = this.choice ? this.choice.value : 'none';
      const usesRileyConfiguration = this.showRileyConfiguration(variant, choice);
      if (choice === 'none' && !usesRileyConfiguration) this.showBedImage(variant);
      this.matches = this.matchingAccessories(choice, color, isXL, wide);
      if (this.item) {
      this.item.replaceChildren(...this.matches.map(v => new Option(v.title, v.id)));
      if (this.matches.some(v => String(v.id) === previous)) this.item.value = previous;
      this.item.hidden = choice === 'none' || this.matches.length < 2;
      const selected = this.matches.find(v => String(v.id) === this.item.value);
      this.price.textContent = choice === 'none' ? '' : selected ? '+' + new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency',currency:this.dataset.currency || 'USD'}).format(selected.price / 100) : 'No matching accessory is currently listed for this size and finish.';
      if (choice !== 'none' && selected && !usesRileyConfiguration) this.showAccessoryImage(choice, selected);
      }
      this.stairMatch = null;
      this.stairModelMatch = null;
      if (this.stairs && this.stairs.value === 'stairs') {
        const accessory = this.accessories.stairs;
        if (accessory && accessory.variants && !this.dataset.stairModel) {
          const ci = accessory.options.findIndex(o => /color|finish/i.test(typeof o === 'string' ? o : o.name));
          this.stairMatch = accessory.variants.find(v => v.available && this.normalize(v.options[ci]) === color);
        }
        if (this.dataset.stairModel && this.accessories.stair_model) {
          const model = this.accessories.stair_model;
          const ci = model.options.findIndex(o => /color|finish/i.test(typeof o === 'string' ? o : o.name));
          const si = model.options.findIndex(o => /size/i.test(typeof o === 'string' ? o : o.name));
          const bedSi = this.bed.options.findIndex(o => /size/i.test(typeof o === 'string' ? o : o.name));
          const sizeKey = v => String(v || '').toLowerCase().replace(/[^a-z0-9]/g,'');
          this.stairModelMatch = model.variants.find(v => v.available && this.normalize(v.options[ci]) === color && sizeKey(v.options[si]) === sizeKey(variant.options[bedSi]));
        }
      }
      if (this.stairPrice) this.stairPrice.textContent = !this.stairs || this.stairs.value === 'none' ? '' : this.dataset.stairModel ? (this.stairModelMatch ? 'Opening the matching stair-ready bunk. Stairs are priced separately.' : 'No stair-ready bunk is currently listed in this size and finish. Choose another finish or contact BEDZ.') : this.stairMatch ? '+' + new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency',currency:this.dataset.currency || 'USD'}).format(this.stairMatch.price / 100) : 'No matching stairs are currently listed for this finish.';
      const checkout = this.form.querySelector('.shopify-payment-button');
      if (checkout) checkout.hidden = this.hasExtras();
    }
    async add() {
      if (this.busy) return;
      this.refresh();
      const accessory = this.item && this.matches.find(v => String(v.id) === this.item.value);
      if ((this.choice && this.choice.value !== 'none' && !accessory) || (this.stairs && this.stairs.value !== 'none' && !this.stairMatch)) { this.error.hidden = false; this.error.textContent = !accessory && this.choice && this.choice.value !== 'none' ? this.price.textContent : this.stairPrice.textContent; return; }
      this.busy = true; this.error.hidden = true;
      const button = this.form.querySelector('[data-product-add]'); button.disabled = true;
      try {
        const data = new FormData(this.form);
        const quantity = Math.max(1, Number(data.get('quantity')) || 1);
        const properties = {};
        for (const [key,value] of data) if (key.startsWith('properties[')) properties[key.slice(11,-1)] = value;
        const bed = {id:Number(data.get('id')),quantity,properties};
        const extras = [accessory, this.stairMatch].filter(Boolean).map(v => ({id:v.id,quantity,properties:{'For bed':this.bed.title}}));
        const response = await fetch(this.dataset.root + 'cart/add.js', {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[bed,...extras]})});
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || this.dataset.error);
        window.location.assign(this.dataset.root + 'cart');
      } catch (error) { this.error.textContent = error.message; this.error.hidden = false; }
      finally { this.busy = false; button.disabled = false; }
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bedz-mattress-layer-content"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function(event) {
    const choice = event.target.closest('[data-layer-image-choice]');
    if (!choice) return;
    const imageSet = choice.closest('[data-bedz-layer-image-set]');
    if (!imageSet) return;
    const selected = choice.dataset.layerImageChoice;
    imageSet.querySelectorAll('[data-layer-image-choice]').forEach(function(button) {
      const active = button === choice;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
    imageSet.querySelectorAll('[data-layer-image]').forEach(function(image) {
      image.hidden = image.dataset.layerImage !== selected;
    });
    const builder = imageSet.closest('[data-bedz-layer-builder]');
    if (builder) {
      builder.querySelectorAll('[data-layer-list]').forEach(function(list) {
        list.hidden = list.dataset.layerList !== selected;
      });
    }
    const caption = imageSet.querySelector('[data-layer-caption]');
    if (caption) caption.textContent = 'Manufacturer construction illustration — ' + choice.textContent.trim();
  });

  function syncMlilyLayerBuilder() {
    const values = Array.from(document.querySelectorAll('.product-details input:checked, .product-details select'))
      .map(function(control) { return String(control.value || '').toLowerCase(); })
      .join(' ');
    let feel = '';
    if (/plush|soft|3\.0/.test(values)) feel = 'plush';
    else if (/firm|1\.0/.test(values)) feel = 'firm';
    if (!feel) return;
    document.querySelectorAll('[data-bedz-layer-image-set]').forEach(function(imageSet) {
      const choice = imageSet.querySelector('[data-layer-image-choice="' + feel + '"]');
      if (choice && choice.getAttribute('aria-pressed') !== 'true') choice.click();
    });
  }

  document.addEventListener('change', function(event) {
    if (event.target.closest('.product-details')) syncMlilyLayerBuilder();
  });
  document.addEventListener('DOMContentLoaded', syncMlilyLayerBuilder);

  document.addEventListener('toggle', function(event) {
    const item = event.target;
    if (!(item instanceof HTMLDetailsElement) || !item.open || !item.classList.contains('bedz-layer-item')) return;
    const builder = item.closest('[data-bedz-layer-builder]');
    if (!builder) return;
    builder.querySelectorAll('.bedz-layer-item[open]').forEach(function(other) {
      if (other !== item) other.open = false;
    });
    const caption = builder.querySelector('[data-layer-caption]');
    const name = item.querySelector('[data-layer-name]');
    if (caption && name) caption.textContent = name.textContent;
  }, true);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bedz-smart-search"] && !Shopify.designMode) return;
  try {
    (() => {
  const configNode = document.getElementById('bedz-search-config');
  if (!configNode) return;
  const config = JSON.parse(configNode.textContent);
  const text = config.text;
  const cache = new Map();
  const aliases = [
    [/\bx[\s\-–—]*plat\b/gi, 'xplat'],
    [/\b(?:t\s*[/\-]\s*f|tf|twin\s*[/\-]\s*full|twin\s+over\s+full)\b/gi, 'twin full'],
    [/\b(?:t\s*[/\-]\s*t|tt|twin\s*[/\-]\s*twin)\b/gi, 'twin over twin'],
    [/\b(?:f\s*[/\-]\s*f|ff|full\s*[/\-]\s*full)\b/gi, 'full over full'],
    [/\b(?:txl|t\s+xl|twinxl|twin\s+x[\s\-]*long|twin\s+extra\s+long)\b/gi, 'twin xl'],
    [/\bbedside\s+tables?\b/gi, 'nightstand'],
    [/\b(?:night|nite)\s+stands?\b/gi, 'nightstand'],
    [/\bnitestands?\b/gi, 'nightstand'],
    [/\bboxsprings?\b/gi, 'box spring'],
    [/\bbunkbeds?\b/gi, 'bunk bed'],
    [/\b(?:matress|mattres|matresses|mattreses)\b/gi, 'mattress'],
    [/\b(?:upolstered|upholstry|upholsterd)\b/gi, 'upholstered'],
    [/\b(?:adjustible|adjutable)\b/gi, 'adjustable'],
    [/\brilley\b/gi, 'riley']
  ];
  const normalize = value => aliases.reduce((q, pair) => q.replace(...pair), value.trim().replace(/\s+/g, ' '));
  const searchURL = (query, original = '') => {
    const url = new URL(config.searchUrl, location.origin);
    url.searchParams.set('q', query);
    url.searchParams.set('type', 'product');
    url.searchParams.set('options[unavailable_products]', 'show');
    url.searchParams.set('options[prefix]', 'last');
    if (original && original.toLowerCase() !== query.toLowerCase()) url.searchParams.set('bedz_original', original);
    return url.pathname + url.search;
  };
  const safeURL = value => {
    try {
      const url = new URL(value, location.origin);
      return url.origin === location.origin ? url.href : '';
    } catch { return ''; }
  };
  const money = value => new Intl.NumberFormat(config.locale, {style:'currency',currency:config.currency}).format(Number(value));
  const notice = document.querySelector('[data-bedz-search-notice]');
  if (notice) {
    const params = new URLSearchParams(location.search);
    const query = params.get('q') || '';
    const original = params.get('bedz_original');
    if (original && original !== query) notice.textContent = `${text.original} “${original.slice(0,160)}”. ${text.matching} “${query}”.`;
    else if (normalize(query).toLowerCase() !== query.toLowerCase()) {
      const link = document.createElement('a');
      link.href = searchURL(normalize(query), query);
      link.textContent = `${text.try} “${normalize(query)}”`;
      notice.append(link);
    }
  }
  let sequence = 0;
  const closeFunctions = [];
  const init = () => {
    document.querySelectorAll('.bedz-search-hero__form, .bedz-global-shopping-header__form, .bedz-sticky-search__form, #search-page-form').forEach(form => {
      if (form.dataset.bedzSuggest) return;
      const input = form.querySelector('input[name="q"]');
      if (!input) return;
      form.dataset.bedzSuggest = 'true';
      const id = `bedz-suggestions-${++sequence}`;
      const panel = document.createElement('div');
      panel.id = id;
      panel.className = 'bedz-search-panel';
      panel.hidden = true;
      panel.setAttribute('role','listbox');
      panel.setAttribute('aria-label',text.label);
      const status = document.createElement('div');
      status.className = 'bedz-search-status';
      status.setAttribute('role','status');
      status.setAttribute('aria-live','polite');
      document.body.append(panel, status);
      input.setAttribute('role','combobox');
      input.setAttribute('aria-controls',id);
      input.setAttribute('aria-expanded','false');
      input.setAttribute('aria-autocomplete','list');
      input.setAttribute('aria-haspopup','listbox');
      input.setAttribute('autocomplete','off');
      if (!input.getAttribute('aria-label')) input.setAttribute('aria-label',text.label);
      let timer, controller, generation = 0, active = -1, wanted = false;
      const hiddenField = (name, value) => {
        let field = Array.from(form.elements).find(el => el.name === name);
        if (!field) { field = document.createElement('input'); field.type='hidden'; field.name=name; form.append(field); }
        field.value = value;
        return field;
      };
      hiddenField('options[prefix]','last');
      hiddenField('type','product');
      hiddenField('options[unavailable_products]','show');
      const close = () => {
        wanted = false;
        panel.hidden = true;
        input.setAttribute('aria-expanded','false');
        input.removeAttribute('aria-activedescendant');
        active = -1;
        status.textContent = '';
      };
      closeFunctions.push(close);
      const position = () => {
        if (panel.hidden) return;
        const rect = form.getBoundingClientRect();
        const viewport = window.visualViewport;
        const topEdge = viewport ? viewport.offsetTop : 0;
        const bottomEdge = topEdge + (viewport ? viewport.height : innerHeight);
        if (!form.getClientRects().length || rect.bottom <= topEdge || rect.top >= bottomEdge) { close(); return; }
        const width = Math.min(Math.max(rect.width, 320), innerWidth - 20);
        const left = Math.max(10, Math.min(rect.left, innerWidth - width - 10));
        panel.style.width = `${width}px`;
        panel.style.left = `${left}px`;
        const below = bottomEdge - rect.bottom - 18;
        if (below < 140 && rect.top - topEdge > below) {
          panel.style.maxHeight = `${Math.max(80, rect.top - topEdge - 18)}px`;
          panel.style.top = `${Math.max(topEdge + 8, rect.top - Math.min(panel.scrollHeight, rect.top - topEdge - 18) - 8)}px`;
        } else {
          panel.style.top = `${rect.bottom + 8}px`;
          panel.style.maxHeight = `${Math.max(80, Math.min(520, below))}px`;
        }
      };
      const open = () => {
        if (!wanted || document.activeElement !== input) return;
        closeFunctions.forEach(fn => { if (fn !== close) fn(); });
        panel.hidden = false;
        input.setAttribute('aria-expanded','true');
        position();
      };
      const addLink = (label, url, className = '') => {
        const href = safeURL(url);
        if (!href) return null;
        const link = document.createElement('a');
        link.href = href;
        link.textContent = label;
        link.className = className;
        link.id = `${id}-option-${panel.querySelectorAll('[role="option"]').length}`;
        link.setAttribute('role','option');
        link.setAttribute('aria-selected','false');
        link.tabIndex = -1;
        panel.append(link);
        return link;
      };
      const message = value => { const p = document.createElement('p'); p.textContent=value; panel.append(p); };
      const group = value => { const p=document.createElement('div'); p.className='bedz-search-group'; p.setAttribute('role','presentation'); p.textContent=value; panel.append(p); };
      const render = (data, query, original, error = false) => {
        panel.replaceChildren(); active=-1; input.removeAttribute('aria-activedescendant');
        if (query.toLowerCase() !== original.toLowerCase()) message(`${text.matching} “${query}”`);
        const products = (data.products || []).filter(p => !window.BedzRankedSearch || window.BedzRankedSearch.visibleForQuery(p,query));
        const need = window.BedzRankedSearch?.sleepNeed(query);
        const guide = config.sleepNeeds?.[need];
        const collections = guide ? [{title:guide.title,url:guide.url}] : (data.collections || []);
        if (products.length) {
          group(guide ? guide.heading : text.products);
          products.slice(0,5).forEach(product => {
            const link = addLink('',product.url);
            if (!link) return;
            const source = product.featured_image?.url || product.image;
            if (source) {
              const imageURL = new URL(source, location.origin);
              if (imageURL.protocol === 'https:') {
                imageURL.searchParams.set('width','120');
                const img=document.createElement('img'); img.src=imageURL.href; img.alt=''; img.width=58; img.height=58; img.loading='lazy'; link.append(img);
              }
            }
            const copy=document.createElement('span'); copy.className='bedz-search-copy';
            const title=document.createElement('span'); title.textContent=product.title; copy.append(title);
            const price=document.createElement('span'); price.className='bedz-search-price';
            price.textContent = `${Number(product.price_max)>Number(product.price_min) ? text.from+' ' : ''}${money(product.price_min ?? product.price)}`;
            copy.append(price); link.append(copy);
          });
        }
        if (collections.length) {
          group(text.categories);
          collections.slice(0,3).forEach(collection => addLink(collection.title, collection.url));
        }
        if (!products.length && !collections.length) message(error ? text.error : text.empty);
        addLink(`${text.view_all} “${original}”`,searchURL(query,original),'bedz-search-all');
        status.textContent = `${panel.querySelectorAll('[role="option"]').length} ${text.results}`;
        open();
      };
      const load = async () => {
        const original=input.value.trim().slice(0,160);
        const query=normalize(original);
        const current=++generation;
        controller?.abort();
        if (query.length<2) { close(); return; }
        wanted=true;
        if (cache.has(query)) { render(cache.get(query),query,original); return; }
        panel.replaceChildren(); active=-1; input.removeAttribute('aria-activedescendant'); message(text.searching); open();
        controller=new AbortController();
        const requestController=controller;
        let timeout;
        try {
          const ranked = window.BedzRankedSearch?.load(query,config.searchUrl);
          if (ranked) {
            try {
              const products = await ranked;
              if (current !== generation) return;
              if (products.length) {
                const data = {products};cache.set(query,data);render(data,query,original);return;
              }
            } catch {}
          }
          timeout=setTimeout(() => requestController.abort(),7000);
          const params=new URLSearchParams({q:query,'resources[type]':'product,collection','resources[limit]':'5','resources[limit_scope]':'each','resources[options][unavailable_products]':'show','resources[options][fields]':'title,product_type,variants.title,vendor,tag,variants.sku'});
          const response=await fetch(`${config.searchUrl}/suggest.json?${params}`,{signal:requestController.signal,headers:{Accept:'application/json'}});
          if (!response.ok) throw new Error('Search unavailable');
          const payload=await response.json();
          if (current!==generation) return;
          const data=payload.resources?.results || {};
          cache.set(query,data); if (cache.size>30) cache.delete(cache.keys().next().value);
          render(data,query,original);
        } catch {
          if (current===generation) render({},query,original,true);
        } finally { clearTimeout(timeout); }
      };
      input.addEventListener('input',() => {
        clearTimeout(timer); generation++; controller?.abort(); close();
        if (!input.matches(':focus') || input.value.trim().length<2) return;
        timer=setTimeout(load,220);
      });
      input.addEventListener('focus',() => { if (input.value.trim().length>=2) { clearTimeout(timer); timer=setTimeout(load,100); } });
      input.addEventListener('keydown',event => {
        if (event.isComposing) return;
        if (event.key==='Escape' || event.key==='Tab') { clearTimeout(timer); generation++; controller?.abort(); close(); return; }
        if (panel.hidden) return;
        const options=Array.from(panel.querySelectorAll('[role="option"]'));
        if (!options.length) return;
        if (event.key==='ArrowDown' || event.key==='ArrowUp') {
          event.preventDefault();
          active=event.key==='ArrowDown' ? (active+1)%options.length : (active<=0 ? options.length-1 : active-1);
          options.forEach((option,index) => option.setAttribute('aria-selected',String(index===active)));
          input.setAttribute('aria-activedescendant',options[active].id);
          options[active].scrollIntoView({block:'nearest'});
        } else if (event.key==='Enter' && active>=0) { event.preventDefault(); location.assign(options[active].href); }
      });
      form.addEventListener('submit',event => {
        const original=input.value.trim();
        if (!original) { event.preventDefault(); input.focus(); return; }
        const query=normalize(original);
        if (query.toLowerCase()!==original.toLowerCase()) hiddenField('bedz_original',original);
        else form.querySelector('input[name="bedz_original"]')?.remove();
        input.value=query;
        close();
      });
      document.addEventListener('pointerdown',event => { if (!form.contains(event.target) && !panel.contains(event.target)) { clearTimeout(timer); close(); } });
      input.addEventListener('blur',() => setTimeout(close,150));
      window.addEventListener('resize',position,{passive:true});
      window.addEventListener('scroll',position,{passive:true});
      window.visualViewport?.addEventListener('resize',position,{passive:true});
      window.visualViewport?.addEventListener('scroll',position,{passive:true});
    });
  };
  if (document.readyState==='loading') document.addEventListener('DOMContentLoaded',init); else init();
  document.addEventListener('shopify:section:load',init);
})();
  } catch(e) { console.error(e); }
})();

})();
